/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_InstallInputs */

const en_pc_online_cmp_install = /** @type {(inputs: Pc_Online_Cmp_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installation`)
};

const zh_pc_online_cmp_install = /** @type {(inputs: Pc_Online_Cmp_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安装`)
};

/**
* | output |
* | --- |
* | "Installation" |
*
* @param {Pc_Online_Cmp_InstallInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_install = /** @type {((inputs?: Pc_Online_Cmp_InstallInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_InstallInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_install(inputs)
	return zh_pc_online_cmp_install(inputs)
});
export { pc_online_cmp_install as "pc.online.cmp.install" }